module.exports = __webpack_public_path__ + "static/media/natoursThumbnail.5afd9cb3.png";